  
<template>
  <div class="editor"
    :class="{'focused':editor_focused||dirty, 'not-focused':!editor_focused&&!dirty}">
    <editor-menu-bubble
      :editor="editor" :keep-in-bounds="keepInBounds" v-slot="{ commands, isActive, menu }">
      <div
        class="menububble"
        :class="{ 'is-active': menu.isActive }"
        :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`">
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold">
          <v-icon small color="white">mdi-format-bold</v-icon>
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic">
          <v-icon small color="white">mdi-format-italic</v-icon>
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline">
          <v-icon small color="white">mdi-format-underline</v-icon>
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list">
          <v-icon small color="white">mdi-format-list-numbered</v-icon>
        </button>
        <button
          class="menububble__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list">
          <v-icon small color="white">mdi-format-list-bulleted</v-icon>
        </button>
      </div>
    </editor-menu-bubble>

    <editor-content class="editor__content" :editor="editor" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Editor, EditorContent, EditorMenuBubble } from 'tiptap'
import {
  Blockquote,
  BulletList,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  ListItem,
  OrderedList,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Focus,
  Placeholder,
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBubble,
  },

  props: {
    note: {
      type: String,
    },

    newnote: {
      type: String,
    },

    html: {
      type: String,
    },

    ing: {
      type: Boolean,
    },

    dirty: {
      type: Number,
    },

    focused: {
      type: Boolean,
    },
  },

  data() {
    return {
      keepInBounds: true,
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Focus({
            className: 'has-focus',
            nested: true,
          }),
          new Placeholder({
            emptyNodeClass: 'is-empty',
            emptyNodeText: 'Start writing...',
            showOnlyWhenEditable: true,
          }),
        ],
        onUpdate: ({ getHTML }) => {
          this.$emit('update:html', getHTML())
          this.$emit('update:ing', true)
        }
      }),
      new_note: null,
      error: false,
    }
  },

  mounted() {
    this.updateData()
  },

  beforeDestroy() {
    this.editor.destroy()
  },

  computed: {
    editor_focused() {
      return this.editor.focused
    },
  },

  watch: {
    note: {
      handler(val) {
        this.new_note = val
        this.$emit('update:html', val)
        this.$emit('update:newnote', this.new_note)
        if (!!this.editor) { this.editor.setContent(val) }
        // if (!val || val=='<p></p>') { this.editor.focus('end') }
      },
      immediate: true,
    },

    editor_focused: {
      handler(val) {
        this.$emit('update:focused', val)
      },
      immediate: true,
    },
  },

  methods: {
    updateData() {
      let vm = this
      setInterval(
        function() {
          if (vm.html != vm.new_note) {
            vm.new_note = vm.html
            vm.$emit('update:newnote', vm.new_note)
          } else {
            vm.$emit('update:ing', false)
          }
        }, 2000
      )
    },
  },
}
</script>

<style>
  .editor {
    padding: 20px;
    background-color: #fafafb;
  }

  .not-focused:hover {
    cursor: pointer;
  }

  .focused {
    border: 1px solid #ff5193;
  }

  .menububble {
    position: absolute;
    display: flex;
    z-index: 20;
    background: black;
    border-radius: 5px;
    padding: 0.3rem;
    margin-bottom: 0.5rem;
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
  }

  .menububble.is-active {
    opacity: 1;
    visibility: visible;
  }

  .menububble__button {
    display: inline-flex;
    background: transparent;
    border: 0;
    color: white;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;
  }

  .menububble__button:last-child {
    margin-right: 0;
  }

  .menububble__button:hover {
    background-color: rgba(white, 0.1);
  }

  .menububble__button:is-active {
    background-color: rgba(white, 0.2);
  }

  .editor p.is-empty:first-child::before {
    color: gray;
    float: left;
    pointer-events: none;
    height: 0;
    font-style: italic;
    content: attr(data-empty-text);
  }
</style>



// WEBPACK FOOTER //
// src/components/shared_components/editor/Tiptap-bubble.vue